import { Component, ViewChild, TemplateRef, Renderer2, OnInit, OnChanges, OnDestroy, AfterViewInit } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { messageService } from 'src/app/message.service';
import { SuccessSnackbarComponent } from 'src/app/support/success-snackbar/success-snackbar.component';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { forkJoin } from 'rxjs';
import { EditorConfig, ST_BUTTONS } from 'ngx-simple-text-editor';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker';
import { qmsService } from '../../qms.service';
import { AuFindingsComponent } from '../au-findings/au-findings.component';
import { AuFollowupsComponent } from '../au-followups/au-followups.component';
import { AuParticipantsComponent } from '../au-participants/au-participants.component';
import { AuRecommendationsComponent } from '../au-recommendations/au-recommendations.component';
import { AuService } from '../au.service';
import { AuQuestionsComponent } from '../au-questions/au-questions.component';
import { TopNavigationComponent } from 'src/app/top-navigation/top-navigation.component';
import { SwitchuserComponent } from 'src/app/support/switchuser/switchuser.component';
import { MatOption } from '@angular/material/core';
import { MatSelect } from '@angular/material/select';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { dynamiclabelService } from 'src/app/dynamiclabel.service';
import { HomepagetagComponent } from 'src/app/homepagetag/homepagetag.component';
import { MatTabGroup } from '@angular/material/tabs';
import { ModuletypeComponent } from 'src/app/moduletype/moduletype.component';
import { DependencyNavigationService } from 'src/app/support/navigation/dependency-navigation.service';
import { FlexibleFieldsComponent } from 'src/app/qms/flexible-fields/flexible-fields.component';
import { CoreNavigationService } from 'src/app/support/navigation/core-navigation.service';
import { QualityDependentsComponent } from '../../quality-dependents/quality-dependents.component';

export interface PopupData {
  title: string;
}
export interface DropDownInterface {
  codelistCode: any;
  codelistName: any;
}

@Component({
  selector: 'app-au-master-page',
  templateUrl: './au-detail-page.component.html',
  styleUrls: ['./au-detail-page.component.scss']
})

export class AuDetailPageComponent implements OnInit, OnChanges, OnDestroy, AfterViewInit {

  infoIconSrc: string = '../../assets/img/info-yellow.png';
  @ViewChild('flexible') flexibleComponent!: FlexibleFieldsComponent;


  isProcessing = false;
  stageName: any;
  buttonLabels: string[] = [];
  actionStatusOptions: any;
  instructions = "";
  saveButtonForTraining: boolean = false;
  auDetailData: any = {};
  participantData: any = {};
  dateCustomClasses: DatepickerDateCustomClasses[];

  auRefNoTxt: any;
  auditCategoryTxt: any;
  auditClassificationTxt: any;
  auMasterTxt: any;
  auditTypeTxt: any;
  functionalAreaOrServicesTxt: any;
  SubGroupTxt: any;
  leadAuditorTxt: any;
  planApproverTxt: any;
  departmentCodeSearchTxt: any;
  reportTemplateValueTxt: any;
  designationCodeTxt: any;
  functionalAreaOrServicesSelected: any;
  pdfColumnSelected: any;
  pdfColumnTxt: any;

  attachAllDocuments: boolean = false;
  event = {
    isUserInput: true,
    source: {
      _selected: true,
    }
  }

  isStageUsersSkipped: boolean = false;
  isAdditionalTabUser: boolean = false;

  constructor(
    public dialog: MatDialog,
    public auService: AuService,
    public message: messageService,
    public qualityService: qmsService,
    public readonly appService: AppService,
    public dynamicLabelService: dynamiclabelService,
    public auFindingsComponent: AuFindingsComponent,
    public auFollowupsComponent: AuFollowupsComponent,
    public auQuestionsComponent: AuQuestionsComponent,
    public auParticipantsComponent: AuParticipantsComponent,
    public auRecommendationsComponent: AuRecommendationsComponent,
    public dependencyNavigationService: DependencyNavigationService,
    private readonly coreNavigationService: CoreNavigationService,
    private readonly renderer: Renderer2,
    private readonly snackBar: MatSnackBar,
  ) {

    const now = new Date();
    this.dateCustomClasses = [{ date: now, classes: ['bg-warning'] }];
    this.qualityService.allowAddandEditForExtension = qualityService.loggedOwner = true;
    this.isAdditionalTabUser = this.qualityService?.userRole[0]?.qmsRoles?.includes("Additional Tab User");
    this.appService.getTaskStages(qualityService.activityId, 0).subscribe((stageUser: any) => {
      this.isStageUsersSkipped = !stageUser.length;
    })
  }

  focusSearch(value: any) {
    setTimeout(() => { let requiredElement = document.getElementById(value); requiredElement?.focus(); }, 0)
  };

  public objectComparisonFunction = function (option: any, value: any): boolean {
    return option.valueExp === value.valueExp;
  };

  @ViewChild(TopNavigationComponent) topNavigationComponent!: TopNavigationComponent;
  openGroupMethod() {
    this.topNavigationComponent.opengroupPopup();
  }

  @ViewChild(QualityDependentsComponent) dependentsComp!: QualityDependentsComponent;
  public openDependentsPopup(): void {
    this.dependentsComp.openPopup();
  }
  selectedAuditGroup: any = []
  selectedAuditType: any = null;
  selectedAuditCategory: any = null;
  selectedFunctionalAreaOrServices: any = [];
  selectedAuditClassification: any = null;
  selectedRoutineIntervalUnit: any = [];
  selectedDepartment: any = [];
  selectedAuMaster: any = null;
  selectedLeadAuditor: any = null;
  selectedScheduleApprover: any = null;
  selectedPlanApprover: any = null;
  selectedAuRefNo: any = null;
  selectedSubGroup: any = null;

  dropDownForAuditGroup: any = [];
  dropDownForAuditType: any = [];
  dropDownForAuditCategory: any = [];
  dropDownForFunctionalAreaOrServices: any = [];
  dropDownForAuditClassification: any = [];
  dropDownForRoutineIntervalUnit: any = [];
  dropDownForDepartment: any = [];
  dropDownForAuMaster: any = [];
  dropDownForLeadAuditor: any = [];
  dropDownForScheduleApprover: any = [];
  dropDownForPlanApprover: any = [];
  dropDownForAuRefNoAndSubGroup: any = [];
  ecPerformerList: any = [];

  auditGroupDropDown: any = [];
  auditTypeDropDown: any = [];
  auditCategoryDropDown: any = [];
  functionalAreaOrServicesDropDown: any = [];
  auditClassificationDropDown: any = [];
  routineIntervalUnitDropDown: any = [];
  departmentDropDown: any = [];
  auMasterDropDown: any = [];
  leadAuditorDropDown: any = [];
  scheduleApproverDropDown: any = [];
  planApproverDropDown: any = [];
  auRefNoDropDown: any = [];
  subGroupDropDown: any = [];

  groupDetailId: any;
  showAuRefNoAsTextBox: any = false;
  showSubGroupAsTextBox: any = false;
  freezeAnnalRefNoDropDown: any = false;
  freezeSubGroupDropDown: any = false;
  objForDocuments: any;
  selectedTab: any;
  selectedTabIndex: any;

  displayFunctionalAreaOrServices: boolean = false;
  freezeAuditTypeDropDown: boolean = true;
  findingVendor: any = [];
  findingDepartment: any = [];
  isForDepartment: boolean = false;
  isForVendor: boolean = false;
  displayVendor: boolean = false;
  displayDepartment: boolean = false;
  specificStageStatus: boolean = false;

  isAuRefNoOdd: any = null;
  isAuditCategoryOdd: any = null;
  isAuditClassificationOdd: any = null;
  isAuMasterOdd: any = null;
  isAuditTypeOdd: any = null;
  isSubGroupOdd: any = null;
  isLeadAuditorOdd: any = null;
  isPlanApproverOdd: any = null;
  isDepartmentCodeSearchOdd: any = null;
  isScheduleApproverOdd: any = null;
  isFunctionalAreaOrServicesOdd: any = null;

  onTabChanged($event: any) {
    this.selectedTab = $event.tab.textLabel;
  }
  showQuestionAndAnswerSectionType: any;

  private clickListener: () => void;
  private boundKeyDown = this.onKeyDown.bind(this);
  private boundKeyUp = this.onKeyUp.bind(this);
  private boundReset = this.resetKeyState.bind(this);

  ngOnInit() {
    this.initiate();

    this.dependencyNavigationService.refresh.subscribe(() => {
      if (this.qualityService.moduleName == 'AU') {
        this.initiate();
      }
    });
  }

  private initiate(): void {
    this.selectedTabIndex = 0;
    document.addEventListener('keydown', this.boundKeyDown);
    document.addEventListener('keyup', this.boundKeyUp);
    window.addEventListener('blur', this.boundReset);
    document.addEventListener('contextmenu', this.boundReset);
    this.isProcessing = true;
    this.ngOnChangesReportFooter();
    this.getDynamicLabel();
    this.message.showDocumentActionButtons = true;
    this.qualityService.onlyReviewerApproverEditable = false;
    this.qualityService.getQmsActionDataUsingById = {};
    this.objForDocuments = {
      id: this.message.activityId,
      pagename: "Activity"
    };

    const loggedGroupId = this.qualityService.selectedActivityGroupId;

    forkJoin([
      this.appService.getCodeListsByGroup('AU_TYPE'),
      this.appService.getCodeListsByGroup('AUDIT_CLASSIFICATION'),
      this.appService.getCodeListsByGroup('AUDIT_ROUTINE_INTERVAL'),
      this.appService.getCodeListsByGroup('AUDIT_CATEGORY'),
      this.appService.getQmsActiveGroupUsers(loggedGroupId, this.qualityService.moduleName, 'Auditor'),
      this.appService.getQmsActiveGroupUsers(loggedGroupId, this.qualityService.moduleName, 'Schedule Approver'),
      this.appService.getQmsActiveGroupUsers(loggedGroupId, this.qualityService.moduleName, 'Plan Approver'),
      this.appService.getQmsActiveGroupUsers(this.qualityService.selectedGroup, this.qualityService.moduleName, 'Effectiveness Check Performer'),
      this.appService.getQmsGroupDetailsByGroupDetailId(loggedGroupId, this.qualityService.selectedGroupDetailId),
      this.appService.getQmsReportTemplateDetailsByModuleAndGroupId(this.qualityService.moduleName, this.qualityService.selectedGroup),
      this.appService.getQmsBusinessAreasByModule('AU')
    ]).subscribe(([typeData, classificationData, intervalUnitData, categoryData, auditorData, scheduleApproverData, plannerData, ecPerformer, groupDetailData, tempData, businessArea]) => {

      this.dropDownDataForReportTemplate = tempData;
      this.selectBoxForReportTemplate();

      this.dropDownForPlanApprover = plannerData;
      this.selectBoxForPlanApprover();

      this.dropDownForAuditClassification = classificationData;
      this.selectBoxForAuditClassification();

      this.dropDownForRoutineIntervalUnit = intervalUnitData;
      this.selectBoxForRoutineIntervalUnit();

      this.dropDownForAuditCategory = categoryData;
      this.selectBoxForAuditCategory();

      this.dropDownForLeadAuditor = auditorData;
      this.selectBoxForLeadAuditor();

      this.dropDownForScheduleApprover = scheduleApproverData;
      this.selectBoxForScheduleApprover();

      this.requestedAtList = businessArea ?? [];
      this.requestedAtList && this.selectBoxForRequestedAt();

      this.ecPerformerList = ecPerformer;

      this.dropDownForAuRefNoAndSubGroup = groupDetailData;
      if (this.dropDownForAuRefNoAndSubGroup.length > 0) {
        this.selectBoxForAuRefNo();
        this.selectBoxForSubGroup();
        this.showAuRefNoAsTextBox = this.showSubGroupAsTextBox = false;
      } else {
        this.showAuRefNoAsTextBox = this.showSubGroupAsTextBox = true;
      }
      this.qualityService.auFindingsList = [];
      this.appService.getAllAuFindingsByAuNo(this.message.activityId).subscribe((data: any) => {
        this.qualityService.auFindingsList = data;
      });
      this.qualityService.auQuestionarie = [];
      this.appService.getQmsAuQuestionsByAuNO(this.message.activityId).subscribe((data: any) => {
        this.qualityService.auQuestionarie = data;
      });
      this.appService.getAuByAuNo(this.message.activityId).subscribe((data: any) => {

        this.parallelWorkflowList = [];
        this.appService.getWorkflowByRefNo(this.qualityService.activityId).subscribe((data: any) => {
          this.parallelWorkflowList = data;
        });


        this.dynamicLabel['REQUESTED_AT']?.isRemovable != 'Y' && data.requestedAt && this.onRequestedAtSelect(this.event, { valueExp: data.requestedAt, displayExp: data.requestedAt });

        data.auditProposedDate = data.auditProposedDate ? new Date(data.auditProposedDate) : null;
        data.scheduleApprovalRequestedOn = data.scheduleApprovalRequestedOn ? new Date(data.scheduleApprovalRequestedOn) : null;
        data.scheduleApprovedOn = data.scheduleApprovedOn ? new Date(data.scheduleApprovedOn) : null;
        data.planApprovalRequestedOn = data.planApprovalRequestedOn ? new Date(data.planApprovalRequestedOn) : null;
        data.planApprovedOn = data.planApprovedOn ? new Date(data.planApprovedOn) : null;
        data.lastActionOn = data.lastActionOn ? new Date(data.lastActionOn) : null;
        data.peerReviewCompletedOn = data.peerReviewCompletedOn ? new Date(data.peerReviewCompletedOn) : null;
        this.auService.isAuditor = data.leadAuditor == this.message.getUserId();
        data.questionAndAnswerSectionType = data.questionAndAnswerSectionType == "Y";
        data.questionAndAnswerSectionType && this.auQuestionsComponent.ngOnInit();
        this.showQuestionAndAnswerSectionType = data.questionAndAnswerSectionType;
        data.isRiskCalculationReqd = data.isRiskCalculationReqd == "Y";
        this.qualityService.activity.isRiskCalculationReqd = data.isRiskCalculationReqd;
        data.effectivenessCheckReqd = data.effectivenessCheckReqd == "Y";
        this.qualityService.activity.effectivenessCheckReqd = data.effectivenessCheckReqd;


        if (this.dynamicLabel['REQUESTED_AT']?.isRemovable != 'Y' && data.requestedAt) {
          const matchingRequestedAt = this.requestedAtList?.find((item: any) => item.taskRequestedAt === data.requestedAt);
          if (!matchingRequestedAt) {
            this.isRequestedAtOdd = data.requestedAt;
            this.requestedAtDropdown.push({
              valueExp: data.requestedAt,
              displayExp: data.requestedAt
            })
          }

          setTimeout(() => {
            if (this.businessAreaDropdown.length) {
              this.selectedBusinessArea = data.coreBusinessAreaName.split(',');
              this.isAllBusinessAreaSelected = this.selectedBusinessArea == this.businessAreaDropdown.length;
            } else {
              [this.selectedBusinessArea, this.isAllBusinessAreaSelected] = [[], false];
            }
          }, 1500)
        }

        if (!this.showAuRefNoAsTextBox && data.annualRefNo && this.dropDownForAuRefNoAndSubGroup.auditAnnualRefList) {
          const matchingAnnualRefNo = this.dropDownForAuRefNoAndSubGroup.auditAnnualRefList.split(',')
            .find((item: any) => item === data.annualRefNo);
          if (matchingAnnualRefNo) {
            this.selectedAuRefNo = matchingAnnualRefNo;
            this.freezeAnnalRefNoDropDown = false;
            this.isAuRefNoOdd = null;
          } else {
            this.dropDownForAuRefNoAndSubGroup.push({
              valueExp: data.annualRefNo,
              displayExp: data.annualRefNo
            });
            this.isAuRefNoOdd = this.selectedAuRefNo = data.annualRefNo;
            this.freezeAnnalRefNoDropDown = true;
          }
        } else {
          this.freezeAnnalRefNoDropDown = false;
        }

        if (data.auditCategory) {
          const matchingAuditCategory = this.auditCategoryDropDown.find((item: any) => item.valueExp == data.auditCategory);
          if (matchingAuditCategory) {
            this.selectedAuditCategory = matchingAuditCategory.valueExp
            this.isAuditCategoryOdd = null;
          } else {
            this.auditCategoryDropDown.push({
              valueExp: data.auditCategory,
              displayExp: data.auditCategory
            });
            this.isAuditCategoryOdd = data.auditCategory;
          }
        }
        this.appService.getTypeSettingsByGrpIdGrpDetailId(loggedGroupId, this.qualityService.selectedGroupDetailId).subscribe((response: any) => {
          this.dropDownForAuditType = response;
          this.selectBoxForAuditType();
          if (data.auditType) {
            const matchingAuditType = this.auditTypeDropDown?.find((item: any) => item.valueExp == data.auditType)
            if (matchingAuditType) {
              this.isAuditTypeOdd = null;
            } else {
              this.isAuditTypeOdd = data.auditType;
              this.auditTypeDropDown.push({
                valueExp: data.auditType,
                displayExp: data.auditType
              });
            }
            this.selectedAuditType = this.qualityService.selectedAuditType = data.auditType.trim();
          }
        })


        if (data.auditType?.toLowerCase().trim() == 'vendor') {
          this.displayVendor = true;
          this.displayDepartment = false;
          this.appService.getQmsVendorsVwDetailsByVendorId(data.vendorId).subscribe((vendorData: any) => {
            data.vendorName = vendorData.vendorName;
            this.dropDownForFunctionalAreaOrServices = [];
            this.dropDownForFunctionalAreaOrServices = vendorData.servicesOffered?.split(',') ?? [];
            this.selectedFunctionalAreaOrServices = [];
            if (data.functionalAreaOrServices) {
              const matchingFinalComplaintCategory = data.functionalAreaOrServices.split(',');
              this.selectedFunctionalAreaOrServices = matchingFinalComplaintCategory;
            }
            this.selectBoxForFunctionalAreaOrServices();
            this.displayFunctionalAreaOrServices = true;
          })
        } else {
          this.displayDepartment = true;
          this.displayVendor = false;
          data.departmentName = data.deptName;
          this.appService.getCodeListsByGroup('AUDIT_DEPARTMENT').subscribe((departmentData: any) => {
            const foundDepartment = departmentData.find((department: any) => data.auditDepartment === department.codelistCode);
            if (foundDepartment) {
              data.departmentId = foundDepartment.codelistCode;
              this.dropDownForFunctionalAreaOrServices = foundDepartment.subgroupValues?.split(',') ?? [];
              this.selectedFunctionalAreaOrServices = [];
              if (data.functionalAreaOrServices) {
                const matchingFinalComplaintCategory = data.functionalAreaOrServices.split(',');
                this.selectedFunctionalAreaOrServices = matchingFinalComplaintCategory;
              }
              this.selectBoxForFunctionalAreaOrServices();
              this.displayFunctionalAreaOrServices = true;
            }
          })
        }
        this.selectedFunctionalAreaOrServices = [];
        if (data.functionalAreaOrServices) {
          const matchingFinalComplaintCategory = data.functionalAreaOrServices.split(',');
          this.selectedFunctionalAreaOrServices = matchingFinalComplaintCategory;
        }
        if (data.leadAuditor) {
          const matchingLeadAuditor = this.leadAuditorDropDown.find((item: any) => item.valueExp == data.leadAuditor);
          if (matchingLeadAuditor) {
            this.isLeadAuditorOdd = null;
          } else {
            this.isLeadAuditorOdd = data.leadAuditor;
            this.leadAuditorDropDown.push({
              valueExp: data.leadAuditor,
              displayExp: data.leadAuditorUser
            });
          }
          this.selectedLeadAuditor = data.leadAuditor;
        }

        if (data.planApprover) {
          const matchingPlanApprover = this.planApproverDropDown.find((item: any) => item.valueExp == data.planApprover);
          if (matchingPlanApprover) {
            this.isPlanApproverOdd = null;
          } else {
            this.isPlanApproverOdd = data.planApprover;
            this.planApproverDropDown.push({
              valueExp: data.planApprover,
              displayExp: data.planApprovedByUser
            });
          }
          this.selectedPlanApprover = data.planApprover
        }

        if (data.scheduleApprover) {
          const matchingScheduleApprover = this.scheduleApproverDropDown.find((item: any) => item.valueExp == data.scheduleApprover);
          if (matchingScheduleApprover) {
            this.selectedScheduleApprover = data.scheduleApprover;
            this.isScheduleApproverOdd = null;
          } else {
            this.selectedScheduleApprover = this.isScheduleApproverOdd = data.scheduleApprover;
            this.scheduleApproverDropDown.push({
              valueExp: data.scheduleApprover,
              displayExp: data.scheduleApprovedByUser
            });
          }
        }

        if (!this.showSubGroupAsTextBox && data.subGroupName && this.dropDownForAuRefNoAndSubGroup.auditSubGroupList) {
          const matchingSubGroupName = this.dropDownForAuRefNoAndSubGroup.auditSubGroupList.split(',')
            .find((item: any) => item === data.subGroupName);
          if (matchingSubGroupName) {
            this.selectedSubGroup = matchingSubGroupName
            this.freezeSubGroupDropDown = false;
          } else {
            this.freezeSubGroupDropDown = true;
            this.selectedSubGroup = data.subGroupName;
          }
        } else {
          this.freezeSubGroupDropDown = false;
        }

        if (data.auditClassification) {
          const matchingAuditClassification = this.auditClassificationDropDown.find((item: any) => item.valueExp == data.auditClassification);
          if (matchingAuditClassification) {
            this.selectedAuditClassification = matchingAuditClassification.valueExp
          } else {
            this.isAuditClassificationOdd = data.auditClassification;
            this.auditClassificationDropDown.push({
              valueExp: data.auditClassification,
              displayExp: data.auditClassification
            });
          }
        }

        this.appService.getAuParticipantsByAuNo(data.auNo).subscribe((participantResponse: any) => {
          const foundPrimaryContactData = participantResponse.find((item: any) => item.isPrimaryContact == 'Y');
          if (foundPrimaryContactData) {
            this.participantData = foundPrimaryContactData;
            this.auService.isAuditee = this.participantData.applicationUserId == this.message.getUserId();
          }
        })

        if (this.auService.auditConductStatusList.includes(this.auDetailData.status)) {
          this.specificStageStatus = false;
        } else {
          this.specificStageStatus = true;
        }

        data.startDate = data.startDate == null ? null : new Date(data.startDate);
        data.endDate = data.endDate == null ? null : new Date(data.endDate);
        data.expectedToBeStartedOn = data.expectedToBeStartedOn == null ? null : new Date(data.expectedToBeStartedOn);
        data.expcetedClosureOn = data.expcetedClosureOn == null ? null : new Date(data.expcetedClosureOn);
        this.auDetailData = data;
        this.frozen();
        if (this.auService.isFromFindingDetails) {
          console.log(this.auService.selectedTabIndex);
          this.selectedTabIndex = this.auService.selectedTabIndex;
          this.auService.isFromFindingDetails = false;
        }

        this.qualityService.activity = data;
        this.qualityService.activity.ownerUserName = data.leadAuditorUser;
        if (this.auService.detailsTabName == "Questionnaire") {
          this.auQuestionsComponent.ngOnInit();
        }
        this.peerReviewerMethod();
        this.closureReviewerMethod();
        this.closureApproverMethod();
        let data1 = {
          activityId: this.message.activityId,
          moduleName: this.qualityService.moduleName,
          status: data.status
        }
        this.appService.getQmsButtons(data1).subscribe((data: any) => {
          this.qualityService.activitySaveButton = false;
          this.qualityService.activityDynamicButtonList = [];
          this.buttonLabels = [];
          let tempbtnlabels: any = [];
          this.qualityService.onlyReviewerApproverEditable = false;
          if (data.resultType == "S") {
            this.stageName = data.stageName;
            this.actionStatusOptions = data.actionStatusOptions;
            this.instructions = data.instructions;
            this.qualityService.activityButtonLabels = data;
            if (data.buttonLabels == null) {
              this.saveButtonForTraining = false;
              this.qualityService.activitySaveButton = false;
              this.buttonLabels.unshift("Cancel");
              this.qualityService.activityDynamicButtonList = this.buttonLabels;
            } else {
              this.buttonLabels = data.buttonLabels.split(",");
              this.buttonLabels.unshift("Cancel");

              this.qualityService.showflexifieldshow = false;
              console.log(this.qualityService.activityDynamicButtonList);
              for (let i = 0; i < this.buttonLabels.length; i++) {
                const condition1 =
                  this.auService.auditScheduleStatusList.includes(data1.status) &&
                  this.auService.auditPlanStatusList.includes(data1.status) &&
                  this.buttonLabels[i] != "Save";

                const condition2 =
                  this.auService.auditConductStatusList.includes(data1.status) &&
                  !this.auService.specificButtonforschedule.includes(this.buttonLabels[i]) &&
                  this.buttonLabels[i] != "Add New Plan" &&
                  this.buttonLabels[i] != "Save";

                if (condition1 || condition2) {
                  tempbtnlabels.push(this.buttonLabels[i]);
                }

                if (this.buttonLabels[i].includes("Submit") || this.buttonLabels[i].includes("Review") || this.buttonLabels[i].includes("Approv") || this.buttonLabels[i].includes("Accept") || this.buttonLabels[i].includes("Accept")) {
                  this.qualityService.showflexifieldshow = true;
                }
                if ((this.qualityService.selectedGroupDetailData.editableByReviewers == "Y" &&
                  (this.auDetailData.status == 'Pending Review' || this.auDetailData.status == 'Review Inprogress') && (this.buttonLabels[i] == 'Review')) ||
                  (this.qualityService.selectedGroupDetailData.editableByApprovers == "Y" &&
                    (this.auDetailData.status == 'Pending Approval' || this.auDetailData.status == 'Approval Inprogress') && (this.buttonLabels[i] == 'Approve'))
                ) {
                  this.qualityService.onlyReviewerApproverEditable = true;
                }

                if (this.buttonLabels[i] == "Save") {
                  this.saveButtonForTraining = true;
                  this.qualityService.activitySaveButton = true;
                  if (this.auDetailData.status == "Pending QA Approval") {
                    this.saveButtonForTraining = false;
                    this.qualityService.activitySaveButton = false;
                  }
                  this.qualityService.activityDynamicButtonList.splice(i, 1);
                }
              }

              this.qualityService.activityDynamicButtonList = [];
              this.qualityService.activityDynamicButtonList = tempbtnlabels;
            }
          } else {
            this.buttonLabels.unshift("Cancel");
            this.qualityService.activityDynamicButtonList = this.buttonLabels;
          }
          if (data.resultType != "S") {
            this.showSnackBar(data.result, data.resultType);
            this.isProcessing = false;
          }
        })
      });
      this.ngOnChanges();
      this.isProcessing = false;
    });
    setTimeout(() => {
      this.functionalAreaOrServicesSelected = this.functionalAreaOrServicesDropDown.length == this.selectedFunctionalAreaOrServices.length;
    }, 500)

    this.isProcessing = true;
    this.appService.getOneQmsOrganizationReportImage().subscribe({
      next: (data: any) => {
        this.organizationReportImageDetails = data;
        this.appService.getQmsReportLogoByModuleAndGroupId("QMS", this.qualityService.selectedGroup).subscribe({
          next: (data: any) => {
            this.dropDownDataForReportLogo = data;
            this.selectBoxForReportLogo();
            this.isProcessing = false;
          }
        });
      },
      error: (error: any) => {
        this.isProcessing = false;
        throw new Error(error);
      }
    });
  };

  label: any = [];
  dynamicLabel: any = null;
  getDynamicLabel() {
    this.dynamicLabel = null;
    this.label = [];
    this.dynamicLabel = null;
    this.isProcessing = true;
    let data = {
      gridName: 'AU_CONDUCT',
      tableName: 'QMS_AU_CONDUCT_VW',
      moduleName: this.qualityService.moduleName,
      groupId: this.qualityService.selectedGroup,
      forLabel: "Y"
    };
    this.appService.getreorderGirdColumnList(data).subscribe({
      next: (labelResponse: any) => {
        this.label = labelResponse;
        this.dynamicLabel = this.label.reduce((acc: any, user: any) => {
          acc[`${user.columnName}`] = {
            fieldName: user.changedFieldName,
            isRemovable: user.isFieldRemovable,
            fieldNotes: user.fieldNotes
          };
          this.qualityService.activityDynamicLabel = acc;
          return acc;
        }, {});
        this.isProcessing = false;
      }, error: (error: any) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }

  requestedAtSearchText: string = '';
  businessAreaSearchText: string = '';
  isRequestedAtOdd: any = null;
  selectedBusinessArea: any = [];
  requestedAtList: any = [];
  businessAreaList: any = [];
  requestedAtDropdown: any = [];
  businessAreaDropdown: any = -[];

  private selectBoxForRequestedAt(): void {
    this.requestedAtDropdown = this.requestedAtList?.filter((x: any) => x.module == 'AU')?.map((item: any) => ({
      valueExp: item.taskRequestedAt,
      displayExp: item.taskRequestedAt
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.trim()?.localeCompare(n?.displayExp?.trim())) || []
  }

  public onRequestedAtSelect(event: any, item: any): void {
    if (event.isUserInput) {

      if (item) {

        this.auDetailData.requestedAtName = item.displayExp;
        const getBusinessArea = this.requestedAtList?.find((x: any) => x.taskRequestedAt == item.displayExp);
        [this.businessAreaList, this.selectedBusinessArea, this.auDetailData.coreBusinessAreaName] = [[], [], null];
        this.businessAreaList = getBusinessArea?.listOfBusinessArea?.split(',');
        this.selectBoxForBusinessArea();

        setTimeout(() => { this.flexibleComponent.triggerFromRequestedAt(item.valueExp) })
      } else {

        this.businessAreaList = [];
        this.businessAreaDropdown = [];
        this.auDetailData.requestedAtName = '';
      }
    }
  }

  private selectBoxForBusinessArea(): void {
    this.businessAreaDropdown = this.businessAreaList?.map((bArea: any) => ({
      valueExp: bArea,
      displayExp: bArea
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.trim()?.localeCompare(n?.displayExp?.trim())) || []
  }

  isAllBusinessAreaSelected?: boolean = false
  public onBusinessAreaSelect(event: any, item: any) {
    if (event.isUserInput)
      setTimeout(() => {
        this.handleDropDownValidation('business-area', this.selectedBusinessArea)
        this.isAllBusinessAreaSelected = this.businessAreaDropdown.length == this.selectedBusinessArea.length;
      });
  }

  @ViewChild('businessArea') businessArea: MatSelect;
  public toggleAllBusinessArea(): void {
    if (this.isAllBusinessAreaSelected) {
      for (const item of this.businessArea.options) item.select();
    } else {
      for (const item of this.businessArea.options) item.deselect();
      this.selectedBusinessArea = [];
    }

    setTimeout(() => { this.handleDropDownValidation('business-area', this.selectedBusinessArea); });
  }

  public getTooltip(): string {
    return this.selectedBusinessArea.join(',');
  }

  @ViewChild('topicPopup', { static: true }) topicPopup: TemplateRef<any>;

  visibleTopicPopup: MatDialogRef<TemplateRef<any>>;

  topicPopupConfig = {
    width: '130%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
    maxWidth: '95vw',
  };

  openTopicPopup() {
    this.message.communicatingFrom = this.qualityService.moduleName;
    this.visibleTopicPopup = this.dialog.open(this.topicPopup, this.topicPopupConfig);
  }
  canceltopicPopup() {
    this.visibleTopicPopup.close();
  }

  disableStatusList = ["Peer Review Rejected ", " Peer Review Inprogress ", " Peer Reviewer Requested More Info. ", " Closure Review Rejected ", " Closure Review Inprogress ", " Closure Reviewer Requested More Info. ", " Closure Approve Rejected ", " Closure Approve Inprogress", " Closure Approver Requested More Info."]

  peerReviewerMethod() {
    this.auService.isPeerReviewer = false;
    this.appService.getTaskStageUsers(this.message.activityId, 0, "Peer Review").subscribe((data: any) => {
      for (const element of data) {
        if (element.taskStageUsersPk.userId == this.message.getUserId()) {
          this.auService.isPeerReviewer = true;
        }
      }
    });
  }

  closureReviewerMethod() {
    this.auService.isClosureReviewer = false;
    this.appService.getTaskStageUsers(this.message.activityId, 0, "Closure Reviewer").subscribe((data: any) => {
      for (const element of data) {
        if (element.taskStageUsersPk.userId == this.message.getUserId()) {
          this.auService.isClosureReviewer = true;
        }
      }
    });
  }

  closureApproverMethod() {
    this.auService.isClosureApprover = false;
    this.appService.getTaskStageUsers(this.message.activityId, 0, "Closure Approver").subscribe((data: any) => {
      for (const element of data) {
        if (element.taskStageUsersPk.userId == this.message.getUserId()) {
          this.auService.isClosureApprover = true;
        }
      }
    });
  }

  ngOnChanges() {
    this.qualityService.refereshBreadCrumb = true;
  }

  selectBoxForAuRefNo() {
    this.auRefNoDropDown = [];
    this.auRefNoDropDown = this.dropDownForAuRefNoAndSubGroup.auditAnnualRefList.split(',').map((item: any) => ({
      valueExp: item,
      displayExp: item
    }));
  }

  public isDropdownDisabled(isFor: any): boolean {
    if (isFor == 'Audit SubCategory') {
      return this.selectedAuditType.length < 1;
    } else if (isFor == 'Annual Audit Reference No') {
      return this.freezeAnnalRefNoDropDown;
    }
    return false;
  }

  selectBoxForAuditClassification() {
    this.auditClassificationDropDown = [];
    this.auditClassificationDropDown = this.dropDownForAuditClassification.map((item: DropDownInterface) => ({
      valueExp: item.codelistCode,
      displayExp: item.codelistName
    }));
  }

  showRoutineFields: boolean;
  onClassificationSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (event.source._selected) {
        if (item.displayExp == 'Routine Audit') this.showRoutineFields = true;
        else this.showRoutineFields = false;
      } else if (this.showRoutineFields) this.showRoutineFields = false;
    }
  }

  onClassificationDeSelect(item: any) {
    if (this.showRoutineFields) this.showRoutineFields = false;
  }

  selectBoxForLeadAuditor() {
    this.leadAuditorDropDown = [];
    this.leadAuditorDropDown = this.dropDownForLeadAuditor.map((item: any) => ({
      valueExp: item.userId,
      displayExp: item.userName
    }))
  }

  selectBoxForScheduleApprover() {
    this.scheduleApproverDropDown = [];
    this.scheduleApproverDropDown = this.dropDownForScheduleApprover.map((item: any) => ({
      valueExp: item.userId,
      displayExp: item.userName
    }))
  }

  selectBoxForPlanApprover() {
    this.planApproverDropDown = [];
    this.planApproverDropDown = this.dropDownForPlanApprover.map((item: any) => ({
      valueExp: item.userId,
      displayExp: item.userName
    }))
  }

  selectBoxForRoutineIntervalUnit() {
    this.routineIntervalUnitDropDown = [];
    this.routineIntervalUnitDropDown = this.dropDownForRoutineIntervalUnit.map((item: DropDownInterface) => ({
      valueExp: item.codelistCode,
      displayExp: item.codelistName
    }));
  }

  onIntervalUnitSelect() {
    this.handleDropDownValidation('internal-unit-validation', this.selectedRoutineIntervalUnit)
  }

  onIntervalUnitDeSelect() {
    this.handleDropDownValidation('internal-unit-validation', this.selectedRoutineIntervalUnit)
  }

  selectBoxForAuditCategory() {
    this.auditCategoryDropDown = [];
    this.auditCategoryDropDown = this.dropDownForAuditCategory.map((item: any) => ({
      valueExp: item.codelistCode,
      displayExp: item.codelistName
    }))
  }

  onAuditCategorySelect(event: any, item: any) {
    if (event.isUserInput) {
      if (event.source._selected) {
        this.displayVendor = this.displayDepartment = this.displayFunctionalAreaOrServices = false;
        this.auDetailData = { ...this.auDetailData, vendorId: '', vendorName: '', departmentId: '', departmentName: '' };
        [this.selectedAuditType, this.selectedFunctionalAreaOrServices] = [[], []];

        if (item.displayExp == 'External') {
          this.findingVendor = this.dropDownForAuditType?.filter((vendor: any) => vendor.type.toLowerCase().trim().includes('vendor')) ?? [];
          if (this.findingVendor.length > 0) {
            let selectedauditType = [{
              valueExp: this.findingDepartment[0].type,
              displayExp: this.findingDepartment[0].type
            }]
            this.selectedAuditType = this.qualityService.selectedAuditType = this.findingVendor[0].type;
            this.freezeAuditTypeDropDown = true;
            this.onAuditTypeSelect(this.event, selectedauditType[0]);
          }
        } else {
          const filteredDepartments = this.dropDownForAuditType?.filter((vendor: any) => !vendor.type.toLowerCase().trim().includes('vendor')) ?? [];
          this.findingDepartment = [...filteredDepartments];

          if (this.findingDepartment.length === 1) {
            let selectedauditType = [{
              valueExp: this.findingDepartment[0].type,
              displayExp: this.findingDepartment[0].type
            }]
            this.selectedAuditType = this.qualityService.selectedAuditType = this.findingDepartment[0].type;
            this.freezeAuditTypeDropDown = true;
            this.onAuditTypeSelect(this.event, selectedauditType[0]);
          } else {
            this.freezeAuditTypeDropDown = false;

            this.auditTypeDropDown = this.findingDepartment?.map((item: any) => ({
              valueExp: item.type,
              displayExp: item.type
            })) ?? [];
          }
        }
      } else {
        this.displayVendor = this.displayDepartment = this.displayFunctionalAreaOrServices = false;
        this.auDetailData = { ...this.auDetailData, vendorId: '', vendorName: '', departmentId: '', departmentName: '' };
        [this.selectedAuditType, this.selectedFunctionalAreaOrServices] = [[], []];
        this.freezeAuditTypeDropDown = true;
      }
    }
  }

  onAuditCategoryDeselect() {
    this.displayVendor = this.displayDepartment = this.displayFunctionalAreaOrServices = false;
    this.auDetailData = { ...this.auDetailData, vendorId: '', vendorName: '', departmentId: '', departmentName: '' };
    [this.selectedAuditType, this.selectedFunctionalAreaOrServices] = [[], []];
    this.freezeAuditTypeDropDown = true;
  }

  selectBoxForAuditType() {
    this.auditTypeDropDown = [];
    this.auditTypeDropDown = this.dropDownForAuditType?.map((item: any) => ({
      valueExp: item.type,
      displayExp: item.type
    })) ?? [];
  }

  onAuditTypeSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (event.source._selected) {
        this.qualityService.selectedAuditType = item;
        this.displayVendor = this.displayDepartment = this.displayFunctionalAreaOrServices = false;
        this.auDetailData = { ...this.auDetailData, vendorId: '', vendorName: '', departmentId: '', departmentName: '' };
        this.selectedFunctionalAreaOrServices = [];

        if (this.selectedAuditType.toLowerCase().trim().includes('vendor')) {
          this.displayVendor = true;
        } else {
          this.displayDepartment = true;
        }
      }
    }
  }

  onAuditTypeDeselect() {
    this.displayVendor = this.displayDepartment = this.displayFunctionalAreaOrServices = false;
    this.auDetailData = { ...this.auDetailData, vendorId: '', vendorName: '', departmentId: '', departmentName: '' };
    this.selectedFunctionalAreaOrServices = [];
  }

  selectBoxForFunctionalAreaOrServices() {
    this.functionalAreaOrServicesDropDown = [];
    this.functionalAreaOrServicesDropDown = this.dropDownForFunctionalAreaOrServices?.map((item: any) => ({
      valueExp: item,
      displayExp: item
    })) ?? []
  }

  @ViewChild('functionalAreaOrServices') functionalAreaOrServices: MatSelect;
  @ViewChild('pdfColumn') pdfColumn: MatSelect;
  allFunctionalAreaSelected = false;
  toggleAllSelection(value: any) {
    if (value == 'functionalAreaOrServices') {
      if (this.functionalAreaOrServicesSelected) {
        this.functionalAreaOrServices.options.forEach((item: MatOption) => item.select());
      } else {
        this.functionalAreaOrServices.options.forEach((item: MatOption) => item.deselect());
      }
    } else if (value == 'pdfColumn') {
      if (this.functionalAreaOrServicesSelected) {
        this.pdfColumn.options.forEach((item: MatOption) => item.select());
      } else {
        this.pdfColumn.options.forEach((item: MatOption) => item.deselect());
      }
    }
  }

  selectBoxForAuMaster() {
    this.auMasterDropDown = [];
    this.auMasterDropDown = this.dropDownForAuMaster.map((item: any) => ({
      valueExp: item.auditMasterId,
      displayExp: item.description
    }))
  }

  onAuMasterSelect(item: any) {
    //this.isProcessing = true
    this.appService.getAuMasterByAuMasterId(item.valueExp).subscribe((data: any) => {

      if (data.auditType) {
        const matchingType = this.dropDownForAuditType.find((item: any) => item.type == data.auditType);
        if (matchingType) {
          this.selectedAuditType = this.qualityService.selectedAuditType = matchingType.type;
        }
      }

      if (data.auditClassification) {
        const matchingClassification = this.dropDownForAuditClassification.find((item: any) => item.codelistCode == data.auditClassification);
        if (matchingClassification) {
          this.selectedAuditClassification = [{
            valueExp: matchingClassification.codelistCode,
            displayExp: matchingClassification.codelistName
          }]

          if (matchingClassification.codelistName == 'Routine Audit') this.showRoutineFields = true;
          else this.showRoutineFields = false;
        }
      }

      if (data.routineIntervalUnit) {
        const matchingIntervalUnit = this.dropDownForRoutineIntervalUnit.find((item: any) => item.codelistCode == data.routineIntervalUnit);
        if (matchingIntervalUnit) {
          this.selectedRoutineIntervalUnit = [{
            valueExp: matchingIntervalUnit.codelistCode,
            displayExp: matchingIntervalUnit.codelistName
          }]
        }
      }

      this.auDetailData = data;
      this.isProcessing = false;
    })
  }

  onAuMasterDeSelect(item: any) {

  }

  selectBoxForSubGroup() {
    this.subGroupDropDown = [];
    this.subGroupDropDown = this.dropDownForAuRefNoAndSubGroup.auditSubGroupList.split(',').map((item: any) => ({
      valueExp: item,
      displayExp: item
    }));
  }

  dateFormat: any = this.appService.organizationDetails?.dateFormat ?? 'DD-MMM-YYYY';;
  commonDateConfig = {
    dateInputFormat: this.dateFormat,
    showWeekNumbers: false,
    containerClass: 'theme-dark-blue',
  };

  auProposedDateConfig = {
    ...this.commonDateConfig,
    minDate: new Date(),
  }

  dateTimeConfig = {
    ...this.commonDateConfig,
    dateInputFormat: this.dateFormat + ' HH:mm:ss'
  }

  onStartedOnChange() {
    if (this.auDetailData.endDate && this.auDetailData.startDate > this.auDetailData.endDate) this.auDetailData.endDate = null;
    this.auEndDateConfig();
  };
  auEndDateConfig() {
    return {
      ...this.commonDateConfig,
      minDate: this.auDetailData.startDate ? new Date(this.auDetailData.startDate) : new Date(),
    }
  }
  primaryauditeeList: any = [];
  isprimaryauditee: boolean = false;
  toggle(event: MatSlideToggleChange) {
    if (event.checked) {
      this.participantListForGrid = [];
    } else {
      for (const element of this.primaryauditeeList) {
        element.participantChildCheckBox = false;
      }
    }

    this.getApplicationUserId = null;
    this.getParticipantName = '';

  }
  searchByVendorName: string;
  searchByVendorCode: string;
  getCheckedVendorName: string;
  getCheckedVendorId: string;
  getCheckedServicesOffered: string;
  showVendorGrid: boolean = false;
  noResultFound: boolean = false;
  vendorList: any = [];

  openVendorPopup() {
    [
      this.searchByVendorName,
      this.searchByVendorCode,
      this.getCheckedVendorName,
      this.getCheckedVendorId,
      this.getCheckedServicesOffered,
      this.vendorList
    ] = ['', '', '', '', '', []];

    this.showVendorGrid = false;
    this.visibleVendorPopup = this.dialog.open(this.vendorPopup, this.vendorPopupConfig);
    this.functionalAreaOrServicesSelected = false;
  }

  cancelVendorPopup() {
    this.visibleVendorPopup.close();
  }

  searchVendorFunc() {
    this.isProcessing = true;
    let data = {
      vendorName: this.searchByVendorName ? this.searchByVendorName : null,
      vendorCode: this.searchByVendorCode ? this.searchByVendorCode : null
    }
    this.appService.fetchVendorListWithSearchCriteria(data).subscribe((vendorData: any) => {
      this.vendorList = vendorData;
      if (this.vendorList.length > 0) this.showVendorGrid = true;
      else this.noResultFound = true;
      this.isProcessing = false;
    })
  }

  resetVendorFunc() {
    [
      this.searchByVendorName,
      this.searchByVendorCode,
      this.getCheckedVendorName,
      this.getCheckedVendorId,
      this.getCheckedServicesOffered,
      this.vendorList
    ] = ['', '', '', '', '', []];
    this.showVendorGrid = false;
  }

  vendorGridCheckBox(e: any, vendorData: any, idx: any) {
    if (e.target.checked) {
      vendorData.vendorChildCheckBoxs = true;
      [this.getCheckedVendorName, this.getCheckedVendorId, this.getCheckedServicesOffered] = [vendorData.vendorName, vendorData.vendorId, vendorData.servicesOffered];
      console.log(this.getCheckedVendorName, this.getCheckedVendorId, "this.getCheckedVendorName, this.getCheckedVendorId");
    } else {
      vendorData.vendorChildCheckBoxs = false;
      [this.getCheckedVendorName, this.getCheckedVendorId] = ['', ''];
    }
  }

  selectVendor() {
    this.isProcessing = true;
    [this.auDetailData.vendorName, this.auDetailData.vendorId, this.dropDownForFunctionalAreaOrServices] = [this.getCheckedVendorName, this.getCheckedVendorId, this.getCheckedServicesOffered?.split(',')];
    this.displayFunctionalAreaOrServices = true;
    this.isProcessing = false;
    this.selectedFunctionalAreaOrServices = [];
    this.selectBoxForFunctionalAreaOrServices();
    this.visibleVendorPopup.close();
  }

  searchByGroupName: string;
  searchByCodeListName: string;
  searchByCodeListCode: string;
  getCheckedDepartmentName: string;
  getCheckedDepartmentCode: string;
  getSubgroupValues: string;
  showDepartmentGrid: boolean = false;
  departmentList: any = [];

  openDepartmentPopup() {
    [
      this.searchByCodeListName,
      this.searchByCodeListCode,
      this.getCheckedDepartmentName,
      this.getCheckedDepartmentCode,
      this.getSubgroupValues,
      this.departmentList
    ] = ['', '', '', '', '', []];

    this.showDepartmentGrid = false;
    this.searchByGroupName = this.selectedAuditType;
    this.visibleDepartmentPopup = this.dialog.open(this.departmentPopup, this.departmentPopupConfig);
    this.functionalAreaOrServicesSelected = false;
  }

  cancelDepartmentPopup() {
    this.visibleDepartmentPopup.close();
  }

  searchDepartmentFunc() {
    this.isProcessing = true;
    let data = {

      groupName:/*  this.searchByGroupName.toUpperCase(), */ 'AUDIT_DEPARTMENT',
      codelistCode: this.searchByCodeListCode ? this.searchByCodeListCode : null,
      codelistName: this.searchByCodeListName ? this.searchByCodeListName : null
    }
    this.appService.fetchDepartmentListWithSearchCriteria(data).subscribe((departmentData: any) => {
      let list = departmentData.filter((x: any) => x.isActive === 'Y');
      this.departmentList = list;
      if (this.departmentList.length > 0) this.showDepartmentGrid = true;
      else this.noResultFound = true;
      this.isProcessing = false;
    })
  }

  resetDepartmentFunc() {
    [
      this.searchByCodeListName,
      this.searchByCodeListCode,
      this.getCheckedDepartmentName,
      this.getCheckedDepartmentCode,
      this.getSubgroupValues,
      this.departmentList
    ] = ['', '', '', '', '', []];
    this.showDepartmentGrid = false;
  }

  departmentGridCheckBox(e: any, departmentData: any, idx: any) {
    if (e.target.checked) {
      departmentData.departmentChildCheckBoxs = true;
      [this.getCheckedDepartmentName, this.getCheckedDepartmentCode, this.getSubgroupValues] = [departmentData.codelistName, departmentData.codelistsPk.codelistCode, departmentData.subgroupValues];
    } else {
      departmentData.departmentChildCheckBoxs = false;
      [this.getCheckedDepartmentName, this.getCheckedDepartmentCode] = ['', ''];
    }
  }

  selectDepartment() {
    [this.auDetailData.departmentName, this.auDetailData.departmentId, this.dropDownForFunctionalAreaOrServices] = [this.getCheckedDepartmentName, this.getCheckedDepartmentCode, this.getSubgroupValues?.split(',')];
    this.selectBoxForFunctionalAreaOrServices();
    this.displayFunctionalAreaOrServices = true;
    this.visibleDepartmentPopup.close();
  }

  searchByUserName: any;
  searchByFirstName: any;
  searchByLastName: any;
  searchByemailAddress: any;
  searchByDesignationCode: any = [];
  searchByDepartmentCode: any = [];
  searchingByStatusCode: any = [];
  designationCodeDropdown: any = [];
  departmentCodeDropdown: any = [];
  participantListForGrid: any = [];
  openParticipantPopup() {
    [
      this.searchByUserName,
      this.searchByFirstName,
      this.searchByLastName,
      this.searchByemailAddress
    ] = new Array(4).fill('');
    this.isprimaryauditee = false;
    this.primaryauditeeList = [];
    this.participantListForGrid = [];
    this.appService.getQmsActiveGroupUsers(this.qualityService.activity.groupId, this.qualityService.moduleName, "Primary Auditee").subscribe((data: any) => {
      this.primaryauditeeList = data;
    });
    [this.searchByDesignationCode, this.searchByDepartmentCode] = [[], []]
    this.visibleParticipantPopup = this.dialog.open(this.participantPopup, this.participantPopupConfig);
  }

  searchParticipant() {
    this.isProcessing = true;
    let data = {
      userName: this.searchByUserName == null ? "" : this.searchByUserName.toUpperCase(),
      firstName: this.searchByFirstName,
      lastName: this.searchByLastName,
      emailAddress: this.searchByemailAddress,
      designationCode: this.searchByDesignationCode[0]?.valueExp ?? null,
      departmentCode: this.searchByDepartmentCode[0]?.valueExp ?? null,
      status: "active"
    };
    this.appService.getOneQmsUsersVwDetails(data).subscribe((response: any) => {
      this.participantListForGrid = response;
      this.isProcessing = false;
    })
  }

  getApplicationUserId: any;
  getParticipantName: string;
  participantChildCheckBoxChecked(e: any, gridData: any, idx: any) {
    if (e.target.checked) {
      this.participantListForGrid.forEach((p: any) => p.participantChildCheckBox = false);
      this.primaryauditeeList.forEach((p: any) => p.participantChildCheckBox = false);
      gridData.participantChildCheckBox = true;
      this.getApplicationUserId = gridData.userId;
      this.getParticipantName = gridData.userName;
    } else {
      gridData.participantChildCheckBox = false;
      this.getApplicationUserId = null;
      this.getParticipantName = '';
    }
  }

  resetParticipant() {
    [
      this.searchByUserName,
      this.searchByFirstName,
      this.searchByLastName,
      this.searchByemailAddress
    ] = new Array(4).fill('');
    this.isprimaryauditee = false;
    [this.searchByDesignationCode, this.searchByDepartmentCode, this.participantListForGrid] = [[], [], []];
  }

  @ViewChild('reasonPopup', { static: true }) reasonPopup: TemplateRef<any>;
  visibleReasonPopup: MatDialogRef<TemplateRef<any>>;
  reasonForSwitch: string = '';
  selectParticipant() {

    if (this.getApplicationUserId == this.participantData.applicationUserId) {
      alert("The same user cannot be switched. Please select a different participant.");
      return;
    }
    this.reasonForSwitch = '';
    this.visibleReasonPopup = this.dialog.open(this.reasonPopup, this.reasonPopupConfig);
  }

  mandatoryValidation(items: any, fieldId: string) {
    const field = document.getElementById(fieldId) as HTMLInputElement;
    field.style.color = items ? '' : 'red';
  }

  reasonPopupConfig = {
    width: '600px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    position: { top: '10px' },
    maxWidth: '95vw',
    disableClose: true
  };

  openConfirmationPopup() {
    if (!this.reasonForSwitch) {
      return this.showSnackBar("Please enter the reason", 'E');
    }
    this.visibleSwitchConfirmationPopup = this.dialog.open(this.switchConfirmationPopup, this.switchConfirmationPopupConfig);
  }

  closeReasonPopup() {
    this.visibleReasonPopup.close();
  }

  @ViewChild('switchConfirmationPopup', { static: true }) switchConfirmationPopup: TemplateRef<any>;
  visibleSwitchConfirmationPopup: MatDialogRef<TemplateRef<any>>;

  switchConfirmationPopupConfig = {
    width: '400px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    position: { top: '10px' },
    maxWidth: '95vw',
    disableClose: true
  };

  executeUserSwitch() {
    this.switchParticipant();
    this.visibleSwitchConfirmationPopup.close();
    this.visibleReasonPopup.close();
    this.visibleParticipantPopup.close();
  }

  closeSwitchConfirmationPopup() {
    this.visibleSwitchConfirmationPopup.close();
  }

  switchParticipant() {
    const obj = {
      ...this.participantData,

    }

    this.isProcessing = true;
    this.appService.updateQmsAuParticipant(obj).subscribe({
      next: (response: any) => {
        if (response?.resultType == 'S') {
          this.createSwitchLog();
        } else {
          this.showSnackBar(response.result, response.resultType);
        }
      },
      error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    })
  }

  createSwitchLog() {
    const obj = {
      switchUserLogId: null,
      module: this.qualityService.moduleName,
      refNo: this.message.activityId,
      version: this.message.version,
      groupId: this.qualityService.selectedGroupDetailData.groupId,
      subModuleName: this.message.submodule,
      subModuleRefNo: this.message.subModuleId,
      userRole: 'Primary Auditee',
      fromUser: this.participantData.applicationUserId,
      toUser: this.getApplicationUserId,
      reasonForSwitch: this.reasonForSwitch,
      status: this.qualityService.activity.status,
      deleteReason: null
    }

    this.appService.createOneQmsSwitchUserLog(obj).subscribe({
      next: (Response: any) => {
        if (Response.resultType == "S") {
          this.participantData.applicationUserId = this.getApplicationUserId;
          this.participantData.participantName = this.getParticipantName;
        }
        this.isProcessing = false;
        this.showSnackBar(Response.result, Response.resultType);
      },
      error: (error) => { this.isProcessing = false; throw error; }
    });
  }

  cancelParticipantSelect() {
    this.visibleParticipantPopup.close();
  }

  singleSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: false,
    allowSearchFilter: true,
    singleSelection: true,
    itemsShowLimit: 1,
    closeDropDownOnSelection: true,
  };

  multiSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: true,
    allowSearchFilter: true,
    singleSelection: false,
  };

  vendorPopupConfig = {
    width: '75%',
    height: '150%',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '60px' },
  };

  departmentPopupConfig = {
    width: '75%',
    height: '150%',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '60px' },
  };

  participantPopupConfig = {
    width: '75%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '20px' },
  };

  editorConfig = {
    width: '100%',
    height: 'auto',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };

  @ViewChild('editor', { static: true }) editor: TemplateRef<any>;
  visibleEditor: MatDialogRef<TemplateRef<any>>;
  @ViewChild('vendorPopup', { static: true }) vendorPopup: TemplateRef<any>;
  visibleVendorPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('departmentPopup', { static: true }) departmentPopup: TemplateRef<any>;
  visibleDepartmentPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('participantPopup', { static: true }) participantPopup: TemplateRef<any>;
  visibleParticipantPopup: MatDialogRef<TemplateRef<any>>;

  config: EditorConfig = {
    buttons: [],
  };

  config1: EditorConfig = {
    buttons: ST_BUTTONS,
  };

  allowEditing: boolean = false;
  editorName: string = '';
  editorTitle: string = '';
  editorValue: string = '';
  public openEditor(value: string, icon: string): void {

    const editorTitleMapping: Record<string, any> = {
      'Lead Auditor Comments': this.dynamicLabel?.['LEAD_AUDITOR_COMMENTS']?.fieldName,
      'Audit Purpose': this.dynamicLabel?.['AUDIT_PURPOSE']?.fieldName,
      'Audit Scope': this.dynamicLabel?.['AUDIT_SCOPE']?.fieldName,
      'Audit References': this.dynamicLabel?.['AUDIT_REFERENCES']?.fieldName,
      'Remarks': this.dynamicLabel?.['REMARKS']?.fieldName,
      'Executive Summary': this.dynamicLabel?.['EXECUTIVE_SUMMARY']?.fieldName,
      'Audit Overall Outcome': this.dynamicLabel?.['AUDIT_OVERALL_OUTCOME']?.fieldName,
      'Conclusion': this.dynamicLabel?.['CONCLUSION']?.fieldName,
    };


    this.allowEditing = icon == 'edit';
    this.editorName = value;
    this.editorTitle = editorTitleMapping[this.editorName];
    this.editorValue = this.auDetailData[this.getModel(value)];
    this.visibleEditor = this.dialog.open(this.editor, this.editorConfig);
  }

  public saveEditor(editorValue: any): void {
    this.auDetailData[this.getModel(this.editorName)] = this.editorValue;
    this.visibleEditor.close();
  }

  private getModel(value: string): any {
    return value.split(' ')
      .map((word: string, index: number) => index === 0 ? word.toLowerCase() : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join('');
  }

  public cancelEditor(): void {
    this.visibleEditor.close();
  };

  showSnackBar(message: string, type: string) {
    this.snackbarRef = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: type === 'S' ? 5000 : undefined,
      data: {
        message,
        type: type === 'S' ? 'Success' : 'Error',
        buttonLabel: 'Ok',
        pageName: this.message.breadcrumbData.thirdLevel ?? this.message.breadcrumbData.secondLevel,
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });

    this.snackbarRef.onAction().subscribe(() => {
      this.snackbarRef.dismiss();
    });
  }

  validateNumberFields(event: KeyboardEvent) {
    const forbiddenKeys = ['E', 'e', '-', '*', '+', '.'];
    if (forbiddenKeys.includes(event.key)) {
      event.preventDefault();
    }
  }

  onNgModuleChange(items: any, fieldId: string) {
    const field = document.getElementById(fieldId) as HTMLInputElement;
    field.style.color = items ? '' : 'red';
  }

  handleDropDownValidation(fieldId: string, selectedItems: any[]) {
    const field = document.getElementById(fieldId) as HTMLInputElement;
    field.style.color = selectedItems.length === 0 && field ? 'red' : '';
  }

  manageValidations(elementIds: string[]) {
    elementIds.forEach((elementId) => {
      const element = document.getElementById(elementId) as HTMLInputElement;
      element.style.color = 'red';
    })
  }

  getColor(status: any) {
    if (!status) return '';

    const lowerCaseStatus = status.toLowerCase();

    switch (true) {
      case lowerCaseStatus.includes('rejected') || lowerCaseStatus.includes('deleted') || lowerCaseStatus.includes('obsoleted'):
        return 'red';
      case lowerCaseStatus.includes('open') || lowerCaseStatus.includes('draft') || lowerCaseStatus.includes('scheduled') || lowerCaseStatus.includes('initiated'):
        return 'orange';
      case lowerCaseStatus.includes('closed') || lowerCaseStatus.includes('completed') || lowerCaseStatus.includes('approved'):
        return 'green';
      default:
        return '';
    }
  }

  statusAppearance(status: string) {
    if (!status) {
      return null;
    }

    let color = '#0f3659';
    let background = '';
    let border = '0.75px solid #0f3659';

    if (status.includes('Rejected') || status.includes('Deleted') || status.includes('Obsoleted')) {
      color = '#FF3A29';
      background = '#FF3A291A';
      border = '0.75px solid #FF3A29';
    } else if (status.includes('Open') || status.includes('Draft') || status.includes('Scheduled') || status.includes('Initiated')) {
      color = '#FF8900';
      background = '#FF89001A';
      border = '0.75px solid #FF8900';
    } else if (status.includes('Closed') || status.includes('Completed') || status.includes('Approved')) {
      color = '#00E58F';
      background = '#00E58F1A';
      border = '0.75px solid #00E58F';
    } else if (status.includes('QA Accepted') || status.includes('Owner Acknowledged') || status.includes('Pending Closure Approval') ||
      status.includes('In Progress') || status.includes('Pending Closure Review') || status.includes('Pending QA Acceptance') ||
      status.includes('Pending Obsolete Approval')) {
      background = '#005C8A1A';
      border = '0.75px solid #005C8A1A';
    }

    return {
      color,
      background,
      border,
      'font-family': 'Poppins',
      'border-radius': '6px',
      'padding': '3px 9px',
      'font-size': '16px !important',
      'font-style': 'normal',
      'font-weight': '500',
      'line-height': '15px'
    };
  }

  selectedTabName: any;
  onTabClick(event: any) {

    this.auService.selectedTabIndex = event.index;
    this.selectedTabName = event.tab.textLabel;
    this.auService.detailsTabName = this.selectedTabName;
    if (event.tab.textLabel == "Findings") {
      this.auFindingsComponent.ngOnInit();
      this.isProcessing = false;
    } else if (event.tab.textLabel == "Participants") {
      this.auParticipantsComponent.ngOnInit();
      this.isProcessing = false;
    } else if (event.tab.textLabel == "Followups") {
      this.auFollowupsComponent.ngOnInit();
      this.isProcessing = false;
    } else if (event.tab.textLabel == "Recommendations") {
      this.auRecommendationsComponent.ngOnInit();
      this.isProcessing = false;
    } else {
      this.isProcessing = false;
    }
  }

  update() {
    let arrayFunctionalArea: any = "";
    for (let k = 0; k < this.selectedFunctionalAreaOrServices.length; k++) {
      arrayFunctionalArea += this.selectedFunctionalAreaOrServices[k];
      arrayFunctionalArea += k == this.selectedFunctionalAreaOrServices.length - 1 ? "" : ",";
    }

    let businessArea = null;
    if (this.dynamicLabel['REQUESTED_AT']?.isRemovable != 'Y' && this.auDetailData.requestedAt) {
      businessArea = this.businessAreaDropdown.length ? this.selectedBusinessArea?.join(',') : this.auDetailData?.coreBusinessAreaName ?? null;
    }

    let auDetailObj = {
      auNo: this.auDetailData.auNo,
      tempAuNo: this.auDetailData.tempAuNo,
      auId: this.auDetailData.auId,
      groupId: this.qualityService.selectedActivityGroupId,
      subGroupName: this.showSubGroupAsTextBox ? this.auDetailData.subGroupName : this.selectedSubGroup ?? null,
      annualRefNo: this.showAuRefNoAsTextBox ? this.auDetailData.annualRefNo : this.selectedAuRefNo ?? null,
      /* intimateToPlanNDaysBefore: this.auDetailData.intimateToPlanNDaysBefore,
      planIntimationEmailUsers: this.auDetailData.planIntimationEmailUsers,
      intimateToConductNDaysBefore: this.auDetailData.intimateToConductNDaysBefore,
      conductIntimationEmailUsers: this.auDetailData.conductIntimationEmailUsers, */
      scheduleApprover: this.selectedScheduleApprover ?? null,
      planApprover: this.selectedPlanApprover ?? null,
      leadAuditor: this.selectedLeadAuditor ?? null,
      leadAuditorComments: this.auDetailData.leadAuditorComments,
      auditType: this.selectedAuditType ?? null,
      auditCategory: this.selectedAuditCategory ?? null,
      auditClassification: this.selectedAuditClassification ?? null,
      auditProposedDate: this.auDetailData.auditProposedDate ? this.appService.dateZoneConvertion(new Date(this.auDetailData.auditProposedDate)) : null,
      startDate: this.auDetailData.startDate ? this.appService.dateZoneConvertion(new Date(this.auDetailData.startDate)) : null,
      endDate: this.auDetailData.endDate ? this.appService.dateZoneConvertion(new Date(this.auDetailData.endDate)) : null,
      ...(this.displayVendor && { vendorId: this.auDetailData.vendorId }),
      ...(this.displayDepartment && { auditDepartment: this.auDetailData.departmentId }),
      functionalAreaOrServices: arrayFunctionalArea,
      /*  auditAddress: this.auDetailData.auditAddress, */
      auditMasterId: this.selectedAuMaster,
      auditPurpose: this.auDetailData.auditPurpose,
      auditScope: this.auDetailData.auditScope,
      auditReferences: this.auDetailData.auditReferences,
      remarks: this.auDetailData.remarks,
      questionAndAnswerSectionType: this.auDetailData.questionAndAnswerSectionType ? "Y" : "N",
      /*   questionAndAnswerSectionType: this.auDetailData.questionAndAnswerSectionType, */
      expectedToBeStartedOn: this.auDetailData.expectedToBeStartedOn ? this.appService.dateZoneConvertion(new Date(this.auDetailData.expectedToBeStartedOn)) : null,
      expcetedClosureOn: this.auDetailData.expcetedClosureOn ? this.appService.dateZoneConvertion(new Date(this.auDetailData.expcetedClosureOn)) : null,
      isRiskCalculationReqd: this.auDetailData.isRiskCalculationReqd ? "Y" : "N",
      effectivenessCheckReqd: this.auDetailData.effectivenessCheckReqd ? "Y" : "N",
      conductIntimationEmailUsers: this.auDetailData.conductIntimationEmailUsers,
      auditOverallOutcome: this.auDetailData.auditOverallOutcome,
      auditOutcomeStatus: this.auDetailData.auditOutcomeStatus,
      conclusion: this.auDetailData.conclusion,
      executiveSummary: this.auDetailData.executiveSummary,
      pageName: 'Conduct',
      shortDescription: this.auDetailData.shortDescription,
      requestedAt: this.dynamicLabel['REQUESTED_AT']?.isRemovable == 'Y' ? null : this.auDetailData.requestedAt,
      coreBusinessAreaName: this.dynamicLabel['REQUESTED_AT']?.isRemovable == 'Y' ? null : businessArea,
    }

    this.appService.updateAu(auDetailObj).subscribe({
      next: (Response: any) => {
        if (Response.resultType == "S") {
          let participantObj = {
            ...this.participantData,

          }

          this.appService.updateQmsAuParticipant(participantObj).subscribe({
            next: (ParticipantResponse: any) => {
              if (ParticipantResponse.resultType == 'S') {
                this.ngOnInit();
                !this.skipValidationsWhileSwitchingUser && this.showSnackBar(Response.result, Response.resultType);
                this.message.lastmsg = Response;
                !this.skipValidationsWhileSwitchingUser && this.flexibleComponent.flexibleFields.length && this.flexibleComponent.save('activity', this.qualityService.activityId);
                this.skipValidationsWhileSwitchingUser && (this.skipValidationsWhileSwitchingUser = false);
              } else {
                this.showSnackBar(ParticipantResponse.result, ParticipantResponse.resultType);
              }
            },
            error: (error) => {
              this.isProcessing = false;
              throw error;
            }
          })

        } else {
          this.showSnackBar(Response.result, Response.resultType);
          this.isProcessing = false;
        }
      },
      error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    })
  }

  // Export Report
  @ViewChild('openExportReportPopup', { static: true }) openExportReportPopup: TemplateRef<any>;
  visibleExportReportPopup: MatDialogRef<TemplateRef<any>>;

  exportReportPopupConfig = {
    width: '35%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };

  dropDownDataForReportTemplate: any;
  selectedReportTemplateValue: any = null;
  reportTemplateDropdown: any = [];
  selectBoxForReportTemplate() {
    this.reportTemplateDropdown = [];
    for (const element of this.dropDownDataForReportTemplate) {
      if (element.subModule == 'AU') {
        this.reportTemplateDropdown = this.reportTemplateDropdown.concat({
          valueExp: element.qmsReportTemplateVwPk.templateId,
          displayExp: element.templateName
        });
      }
    }
  }

  templateid: number;
  pdfDetailSearchText: string = '';
  onPdfDetailValueSelect(event: any, item: any) {
    if (event.isUserInput) {
      this.templateid = item;
      if (this.reportTemplateFieldValidation != undefined) {
        this.reportTemplateFieldValidation.style.color = '#005c8a';
      }
    }
  }

  onReportTemplateRemoved(item: any) {
    this.reportTemplateFieldValidation = document.getElementById('reportTemplate-validation') as HTMLInputElement;
    if (this.selectedReportTemplateValue == null) {
      if (this.reportTemplateFieldValidation != undefined) {
        this.reportTemplateFieldValidation.style.color = 'red';
      }
    }
  };
  openExportPopup() {
    const firstst = this.message.breadcrumbData.firstLevel;
    const secondnd = this.message.breadcrumbData.secondLevel;
    const thirdL = this.message.breadcrumbData.thirdLevel;
    const fourthL = this.message.breadcrumbData.fourthLevel;
    let fileName = "";
    if (firstst != null) {
      fileName = firstst + "_";
    }
    if (secondnd != null) {
      fileName = fileName + secondnd + "_";
    }
    if (thirdL != null) {
      fileName = fileName + thirdL + "_";
    }
    if (fourthL != null) {
      fileName = fileName + fourthL + "_";
    }
    this.reportName = fileName + Date.now();
    for (const element of this.dropDownDataForReportTemplate) {
      if (element.isDefault == 'Y' && element.subModule == 'AU') {
        this.selectedReportTemplateValue = element.qmsReportTemplateVwPk.templateId;
      }
    }
    this.visibleExportReportPopup = this.dialog.open(this.openExportReportPopup, this.exportReportPopupConfig);
  }
  cancelExportPopup() {
    this.visibleExportReportPopup.close();
  }

  reportTemplateFieldValidation: any;
  exportReportGenerateFuntion() {
    this.reportTemplateFieldValidation = document.getElementById('reportTemplate-validation') as HTMLInputElement;
    if (this.selectedReportTemplateValue) {
      let data1: any = {};

      this.auDetailData.templateId = 17337;
      let y: number = +this.message.getUserId();
      this.auDetailData.userId = y

      let thirdL = this.message.breadcrumbData.secondLevel.split('>');
      data1 = {
        "groupId": this.qualityService.activity.groupId + "",

        "gridName": "AU",
        "templateId": this.selectedReportTemplateValue ?? null,
        "logoId": this.selectedReportLogoValue ?? null,
        "isSaveRep": this.isSaveReport ? 'Y' : 'N',
        "attachAllDocuments": this.attachAllDocuments ? 'Y' : 'N',
        "footer": this.selectedReportFooter ?? null,
        "reportName": this.reportName ?? "AU_Report",
        "currentStatus": this.qualityService.activity.status,
        "groupName": thirdL[1],
        "templateName": this.selectedReportTemplateValue ?? null,
        "AUid": this.message.activityId,
        "version": "0",
        "AUId": this.qualityService.activity.auId

      }
      this.isProcessing = true;
      this.appService.genRateAUReport(data1).subscribe((response: any) => {
        const blob = new Blob([response.body], { type: "application/pdf" });
        let downloadURL = globalThis.URL.createObjectURL(blob);
        let link = document.createElement('a');
        link.href = downloadURL;
        const firstst = this.message.breadcrumbData.firstLevel;
        const secondnd = this.message.breadcrumbData.secondLevel;
        const thirdL = this.message.breadcrumbData.thirdLevel;
        const fourthL = this.message.breadcrumbData.fourthLevel;

        let fileName = "";
        if (firstst != null) {
          fileName = firstst + "_";
        }
        if (secondnd != null) {
          fileName = fileName + secondnd + "_";
        }
        if (thirdL != null) {
          fileName = fileName + thirdL + "_";
        }
        if (fourthL != null) {
          fileName = fileName + fourthL + "_";
        }
        link.download = fileName + Date.now() + ".pdf";
        link.click();
        this.isProcessing = false;
      })
    } else {
      alert('Please enter the all mandatory fields...');
      this.reportTemplateFieldValidation.style.color = 'red';
    }
  }

  exportReportCancelPopupFuntion() {
    this.visibleExportReportPopup.close();
  }
  //PDF report code end

  lockActivity(): boolean {
    const today = new Date();
    today.setHours(0, 0, 0, 0); // strip time

    const closureDate = new Date(this.qualityService.activity.expcetedClosureOn);
    closureDate.setHours(0, 0, 0, 0);

    if (today > closureDate && this.qualityService.selectedGroupDetailData?.isExtensionRequired == 'Y') {
      setTimeout(() => {
        this.showSnackBar("The activity closure date has passed. Please extend the date to proceed!", 'E');
      }, 100);
      return true;
    } else {
      return false;
    }
  }

  @ViewChild(SwitchuserComponent) switchuserComponent!: SwitchuserComponent;
  async openswitchuser(value: any) {
    if (this.qualityService.activity.status == "In Progress" && value != "LeadAuditor" && await this.qualityService.validateExtension({ refNo: this.qualityService.activityId, extensionFor: "Activity" })) {
      setTimeout(() => {
        this.showSnackBar(this.qualityService.extensionResult, 'E');
      }, 0);
      this.isProcessing = false;
      return;
    } else { this.isProcessing = false; }
    this.message.switchedUser = [];
    this.message.switchUserdropDownList = [];
    this.message.submodule = null;
    this.message.switchuserRole = value;
    if (value == "LeadAuditor") {
      this.message.switchedUser = this.selectedLeadAuditor;
      this.auService.selectedLeadAuditor = this.selectedLeadAuditor;
      this.message.switchUserCurrentValue = this.selectedLeadAuditor;
      this.message.switchUserdropDownList = this.leadAuditorDropDown.filter((auditor: any) => auditor.valueExp != this.participantData.applicationUserId).map((item: any) => ({
        valueExp: item.valueExp,
        displayExp: item.displayExp
      })) ?? []
    } else if (value == "ScheduleApprover") {
      this.message.switchedUser = this.selectedScheduleApprover;
      this.auService.selectedScheduleApprover = this.selectedScheduleApprover;
      this.message.switchUserCurrentValue = this.selectedScheduleApprover;
      this.message.switchUserdropDownList = this.scheduleApproverDropDown.map((item: any) => ({
        valueExp: item.valueExp,
        displayExp: item.displayExp
      })) ?? []
    } else if (value == "PlanApprover") {
      this.message.switchedUser = this.selectedPlanApprover;
      this.auService.selectedPlanApprover = this.selectedPlanApprover;
      this.message.switchUserCurrentValue = this.selectedPlanApprover;
      this.message.switchUserdropDownList = this.planApproverDropDown.map((item: any) => ({
        valueExp: item.valueExp,
        displayExp: item.displayExp
      })) ?? []
    }
    this.switchuserComponent.openswitchuser(value, "AU");
  };

  skipValidationsWhileSwitchingUser: boolean;
  onChildValueEmitted() {
    if (this.message.switchuserRole == "LeadAuditor") {
      this.selectedLeadAuditor = this.message.switchedUser;
    }
    else if (this.message.switchuserRole == "ScheduleApprover") {
      this.selectedScheduleApprover = this.message.switchedUser;
    }
    else if (this.message.switchuserRole == "PlanApprover") {
      this.selectedPlanApprover = this.message.switchedUser;
    }
    this.skipValidationsWhileSwitchingUser = true;
    this.switchuserComponent.saveMethod();
    this.switchuserComponent.visibleswitchUserPopup.close();
    this.switchuserComponent.visibleConfirmationPopup.close();
    this.update();
  }

  snackbarRef: any;
  ngAfterViewInit() {
    /* Listener for document click */
    this.clickListener = this.renderer.listen('document', 'click', () => {
      if (this.snackbarRef) {
        this.snackbarRef.dismiss();
      }
    });
  }


  ctrlPressed: boolean = false;
  shiftPressed: boolean = false;
  ngOnDestroy() {
    document.removeEventListener('keydown', this.boundKeyDown);
    document.removeEventListener('keyup', this.boundKeyUp);
    window.removeEventListener('blur', this.boundReset);
    document.removeEventListener('contextmenu', this.boundReset);
    if (this.clickListener) {
      this.clickListener();
    }
  }

  onKeyDown(event: KeyboardEvent) {
    if (event.key === 'Control') {
      this.ctrlPressed = true;
    } else if (event.key === 'Shift') {
      this.shiftPressed = true;
    }
  }

  onKeyUp(event: KeyboardEvent) {
    if (event.key === 'Control') {
      this.ctrlPressed = false;
    } else if (event.key === 'Shift') {
      this.shiftPressed = false;
    }
  }

  resetKeyState() {
    this.ctrlPressed = false;
    this.shiftPressed = false;
  }

  onPaste(event: ClipboardEvent) {
    const isAllowedPaste = this.ctrlPressed && this.shiftPressed;
    if (!isAllowedPaste) {
      event.preventDefault();
      this.showSnackBar("You can't perform this operation. Please use Ctrl + Shift + V to paste the content", 'E');
    }
  }
  addworkflow: boolean = false;
  parallelWorkflowList: any = [];
  async openAddWorkflow() {
    if (this.qualityService.activity.status == "In Progress" && await this.qualityService.validateExtension({ refNo: this.qualityService.activityId, extensionFor: "Activity" })) {

      setTimeout(() => {
        this.showSnackBar(this.qualityService.extensionResult, 'E');
      }, 0);
      this.isProcessing = false;
    } else this.addworkflow = true;
    this.isProcessing = false;
  };


  onworkflowChildValueEmitted() {
    this.parallelWorkflowList = null;
    this.appService.getWorkflowByRefNo(this.qualityService.activityId).subscribe((data: any) => {
      this.parallelWorkflowList = data;
    });
    this.addworkflow = false;
  }

  onFunctionalAreaSelect(event: any, item: any) {
    if (event.isUserInput) {
      setTimeout(() => {
        this.functionalAreaOrServicesSelected = this.functionalAreaOrServicesDropDown.length == this.selectedFunctionalAreaOrServices.length;
      })
    }
  }


  @ViewChild(HomepagetagComponent) homepagetagComponent!: HomepagetagComponent;
  openTag() {
    let data = {
      pageName: 'Detail',
      labelName: "Tag",
      tagRef: this.auDetailData.auId
    }
    this.homepagetagComponent.openpopup(data);
  }

  onTagChildValueEmitted() {
  };

  dropDownDataForReportLogo: any;
  selectedReportLogoValue: any = null;
  reportLogoFieldValidation: any;
  reportLogoDropdown: any = [];
  imageIdList: any = [];
  organizationReportImageDetails: any = {};
  logoVals: any;
  isSaveReport: boolean = false;
  reportName: any;
  onReportLogoValueSelect(event: any, item: any) {
    if (event.isUserInput) {
      this.templateid = item;
      if (this.reportLogoFieldValidation != undefined) {
        this.reportLogoFieldValidation.style.color = '#005c8a';
      }
    }
  }

  selectBoxForReportLogo() {
    this.reportLogoDropdown = [];
    if (this.dropDownDataForReportLogo) {
      if (this.dropDownDataForReportLogo.reportImageList == 'Default') {
        this.reportLogoDropdown = this.reportLogoDropdown.concat({
          valueExp: 0,
          displayExp: 'Default'
        });
      } else if (this.dropDownDataForReportLogo.reportImageList.includes(",")) {
        this.imageIdList = this.dropDownDataForReportLogo.reportImageList.split(",");
        for (let i = 0; i < this.imageIdList.length; i++) {
          if (i == 0 && this.imageIdList[i] == 'Default') {
            this.reportLogoDropdown = this.reportLogoDropdown.concat({
              valueExp: 0,
              displayExp: 'Default'
            });
          } else {
            for (const element of this.organizationReportImageDetails) {
              if (element.reportImageId == this.imageIdList[i]) {
                this.reportLogoDropdown = this.reportLogoDropdown.concat({
                  valueExp: element.reportImageId,
                  displayExp: element.reportImageName
                });
              }

            }
          }
        }
      } else {
        for (const element of this.organizationReportImageDetails) {
          if (element.reportImageId == this.dropDownDataForReportLogo.reportImageList) {
            this.reportLogoDropdown = this.reportLogoDropdown.concat({
              valueExp: element.reportImageId,
              displayExp: element.reportImageName
            });
          }
        }
      }
      if (this.dropDownDataForReportLogo.defaultReportName != 'Default' && this.dropDownDataForReportLogo.defaultReportName != null) {
        for (const element of this.reportLogoDropdown) {
          if (element.valueExp == this.dropDownDataForReportLogo.defaultReportName) {
            this.selectedReportLogoValue = element.valueExp;
          }
        }
      } else {
        this.selectedReportLogoValue = this.reportLogoDropdown[0].valueExp;
      }
    } else {
      this.selectedReportLogoValue = [];
    }
  };

  openRiskSettingTab() {
    this.goToTabByLabel("Risk Assessment");
  };

  @ViewChild('tabsGroup', { static: false }) tabsGroup: MatTabGroup;
  set tabGroup(tabGroup: MatTabGroup) {
    if (tabGroup)
      setTimeout(() => {
        this.selectedTabIndex = tabGroup._tabs["_results"].find((t: any) => t.textLabel == this.selectedTabIndex).position;
        this.auService.selectedTabIndex = this.selectedTabIndex;
      }, 0);
  }

  goToTabByLabel(label: string) {
    if (this.tabsGroup) {
      const tabs = (this.tabsGroup?._tabs as any)._results,
        match = tabs?.find((x: any) => x.textLabel?.toUpperCase() === label.toUpperCase());

      if (match) {
        this.tabsGroup.selectedIndex = match.position;
      }
    }
  };


  @ViewChild(ModuletypeComponent) moduleTypeComponent!: ModuletypeComponent;
  openModuleType: boolean = false;
  moduleTypeData: any;
  value: any;
  openUpdateType() {
    this.moduleTypeData = {
      dropdownList: this.auditTypeDropDown,
      moduleTypeValue: this.selectedAuditType,
      // expcetedClosureOn:this.qualityService.capaPageAllDropdownValues.expcetedClosureOn ,
      // expectedToBeStartedOn:this.qualityService.capaPageAllDropdownValues.expectedToBeStartedOn,
      moduleName: this.dynamicLabel['AUDIT_TYPE'].fieldName,
      // moduleStartedOnName:this.dynamicLabel['STARTED_ON'].fieldName,
      // moduleclosedOnName:this.dynamicLabel['COMPLETED_ON'].fieldName
    }
    this.openModuleType = true;
    this.moduleTypeComponent.openpopup(this.moduleTypeData);
    //
  }
  onModuleTypeEmitted($event: any) {
    this.openModuleType = false;
    this.selectedAuditType = $event.moduleType;
    this.update();
  }

  /* The following fields in the Audit — Start Date, End Date, Audit Outcome Status, Executive Summary, Conclusion, Audit Overall Outcome, Risk Calculation Reqd, Requested At, Core Business Area and Lead Auditor Comments —
   are controlled using the isFrozen flag and are editable only by the Lead Auditor in specific statuses.
   All other fields in the Audit Details are permanently frozen using the freezePermanently flag */
  freezePermanently: boolean = true;
  isFrozen: boolean = false;
  frozen() {

    const status = this.auDetailData.status;

    this.isFrozen = !(this.auService.isAuditor && (status === 'In Progress'
      || status === 'In Progress/Received Q&A Response'
      || status === 'Received Q&A Response'
      || status === 'Peer Review Rejected'
      || status === 'Peer Reviewer Requested More Info.'
      || status === 'Findings In Progress'
      || status === 'Auditee Requested More Info.'
      || status === 'Auditee Accepted'
      || status === 'Closure Review Rejected'
      || status === 'Closure Reviewer Requested More Info.'
      || status === 'Closure Approval Rejected'
      || status === 'Closure Approver Requested More Info.'));

    this.message.showDependencyActionButton = this.auService.isAuditor && (status === 'In Progress'
      || status === 'In Progress/Received Q&A Response'
      || status === 'Peer Review Rejected'
      || status === 'Peer Reviewer Requested More Info.'
      || status === 'Findings In Progress'
      || status === 'Auditee Requested More Info.'
      || status === 'Auditee Accepted'
      || status === 'Closure Review Rejected'
      || status === 'Closure Reviewer Requested More Info.'
      || status === 'Closure Approval Rejected'
      || status === 'Closure Approver Requested More Info.');

    this.message.showReviewApproveActionButtons = this.auService.isAuditor && (status === 'Initiated'
      || status === 'Initiated/Received Q&A Response'
      || status === 'In Progress'
      || status === 'In Progress/Received Q&A Response'
      || status === 'In Progress/Auditor Requested More Info. On Q&A Responses'
      || status === 'Received Q&A Response'
      || status === 'Peer Review Rejected'
      || status === 'Peer Reviewer Requested More Info.'
      || status === 'Closure Review Rejected'
      || status === 'Closure Reviewer Requested More Info.'
      || status === 'Closure Approval Rejected'
      || status === 'Closure Approver Requested More Info.'
    );

    this.qualityService.elite_AccessToClosure_Reviewer_Approver = (status == "Auditee Requested More Info." || status == "Auditee Accepted" || status == "Findings In Progress") && this.auService.isAuditor
    setTimeout(() => {
      this.flexibleComponent?.main();
    });

    const isEcPerformer = this.message.isEcPerformer = this.ecPerformerList.find((user: any) => user.userId === +this.message.getUserId());

    if (this.auDetailData.status === 'Closed') {
      this.appService.getQmsTasksEC(this.qualityService.activityId).subscribe((data: any) => {
        this.message.showEffectiveSection = (data.length > 0) || this.qualityService.activity.effectivenessCheckReqd;
        this.message.showEffectiveActionButtons = isEcPerformer || this.auService.isAuditor;
      })
    } else {
      this.message.showEffectiveSection = this.message.showEffectiveActionButtons = false;
    }
  }

  limitCharacters(event: Event, field: any) {
    const target = event.target as HTMLInputElement | HTMLTextAreaElement;
    const textLength = target.value.length;
    let charLimit: any = null;

    const fieldMapping: Record<number, string[]> = {
      4000: ['SHORT_DESCRIPTION']
    };

    for (const [limit, fields] of Object.entries(fieldMapping)) {
      if (fields.includes(field)) {
        charLimit = Number(limit);
        break;
      }
    }

    if (textLength > charLimit) {
      this.showSnackBar("Maximum " + charLimit + " Characters!", 'E');
      target.value = target.value.substring(0, charLimit);
    }
  }

  reportFooterfieldValidation1: any;
  selectedReportFooter: any;
  reportFooterDropdown1: any = [];
  reportFooterDropdown: any = [];
  onReportFooterSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (this.reportFooterfieldValidation1 != undefined) {
        this.reportFooterfieldValidation1.style.color = '#005c8a';
      }
    }
  }

  ngOnChangesReportFooter() {
    this.appService.getCodeListsByGroup("REPORT_FOOTER").subscribe({
      next: (data: any) => {
        this.reportFooterDropdown1 = data;

        this.selectBoxForFooter();
        if (this.reportFooterDropdown.length > 0) {
          this.selectedReportFooter = this.reportFooterDropdown[0].displayExp;
        }
      },
      error: (error: any) => {
        this.isProcessing = false;
      }
    });
  }

  selectBoxForFooter() {
    this.reportFooterDropdown = [];
    for (const vals of this.reportFooterDropdown1) {
      if (vals.moduleList == "Common" || vals.moduleList.includes(this.qualityService.moduleName)) {
        this.reportFooterDropdown.push({
          valueExp: vals.codelistName,
          displayExp: vals.codelistName
        });
      }
    }
  }

  private readonly model: {
    documents: any[];
    stagesUser: any[];
    extension: any[];
    effectiveness: any[];
    dependency: any[];
    parallelWorkFlow: any[];
  } = {
      documents: [],
      stagesUser: [],
      extension: [],
      effectiveness: [],
      dependency: [],
      parallelWorkFlow: [],
    };

  public on_documents_emit($event: any): void {
    this.model.documents = $event.action;
  }

  public on_stageUser_emit($event: any): void {
    this.model.stagesUser = $event.stages;
  }

  public on_extension_emit($event: { $extension: any[], $destroying?: boolean }): void {
    if ($event?.$destroying) {
      this.appService.getAuByAuNo(this.qualityService.activityId).subscribe((au: any) => {
        this.auDetailData.expcetedClosureOn = this.qualityService.activity.expcetedClosureOn = new Date(au.expcetedClosureOn);
      })
    }

    this.model.extension = $event.$extension;
  }

  public on_effectiveness_emit($event: any): void {
    this.model.effectiveness = $event.effectiveness;
  }

  public on_dependency_emit($event: any): void {
    this.model.dependency = $event.dependency;
  }

  public on_parallelWorkFlow_emit($event: any): void {
    this.model.parallelWorkFlow = $event.parallelWorkFlow;
  }

  onParticipantRefresh(event: any) {
    this.appService.getAuParticipantsByAuNo(this.auDetailData.auNo).subscribe((participantResponse: any) => {
      const foundPrimaryContactData = participantResponse.find((item: any) => item.isPrimaryContact == 'Y');
      if (foundPrimaryContactData) {
        this.participantData = foundPrimaryContactData;
        this.auService.isAuditee = this.participantData.applicationUserId == this.message.getUserId();
      }
    });
  }

  public getSwitchUserPrivilege(): boolean {
    return this.message.showSwitchUser && this.auDetailData.status != "Obsoleted" && this.auDetailData.status != "Deleted";
  }

}
